<template>
  <div v-if="show">
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.advt_tax') }}
    </div>
    <div class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
          <div class="dialog-add-account__form-item">
            <div class="form-input" :class="{ 'form-input--full': value >= 0 }">
              <input
                :value="value"
                type="number"
                step="0.01"
                min="0"
                max="100"
                :disabled="disabled"
                @input="$emit('input', parseFloat($event.target.value) || 0)"
              />
              <span class="form-input__label">
                {{ $t('business_account_data.advt_tax_placeholder') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvertisingTaxInput',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['input'],
};
</script>
